class SearchForm extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="search"]');
    this.resetButton = this.querySelector('button[type="reset"]');
    this.searchAnimatedForm = this.querySelectorAll('form.search');

    if (this.input) {
      this.input.form.addEventListener('reset', this.onFormReset.bind(this));
      this.input.addEventListener(
        'input',
        debounce((event) => {
          this.onChange(event);
        }, 300).bind(this)
      );
    }

    this.animatedInput();
  }

  animatedInput() {
    this.searchAnimatedForm.forEach(function(event) {
      const searchAnimatedContainer = event.querySelector('label.field__label span.animated-label-text');
      const searchAnimatedStyle = event.dataset.animated_style;
      const searchAnimatedText = event.dataset.animated_text;
      if (!searchAnimatedText) return;
      const searchAnimatedArray = searchAnimatedText.split('\n');
      const searchModifiedArray = searchAnimatedArray.map(item => { return item; });
      if (searchModifiedArray.length > 1 && searchAnimatedStyle !== 'none') {
        let searchAnimatedIndex = 0;
        let searchAnimatedCharIndex = 0;
        let searchAnimatedDelete = false;
        if (searchAnimatedStyle == 'fade') {
          // Fade In Words
          function showNextWord() {
            if (searchAnimatedIndex < searchModifiedArray.length) {
              searchAnimatedContainer.textContent = searchModifiedArray[searchAnimatedIndex];
              searchAnimatedContainer.style.transition = "opacity 0.5s ease-in-out";
              searchAnimatedContainer.style.opacity = '1';
              setTimeout(() => {
                searchAnimatedContainer.style.opacity = '0';
                searchAnimatedIndex++;
                setTimeout(showNextWord, 1000);
              }, 2000);
            } else {
              searchAnimatedIndex = 0;
              setTimeout(showNextWord, 300);
            }
          }
          showNextWord();
        } else {
          // Typed
          function searchTypedWord() {
            const searchCurrentWord = searchModifiedArray[searchAnimatedIndex % searchModifiedArray.length];
            if (searchAnimatedDelete) {
              searchAnimatedContainer.textContent = searchCurrentWord.substring(0, searchAnimatedCharIndex - 1);
              searchAnimatedCharIndex--;
            } else {
              searchAnimatedContainer.textContent = searchCurrentWord.substring(0, searchAnimatedCharIndex + 1);
              searchAnimatedCharIndex++;
            }
            let searchTypeSpeed = 300;
            if (searchAnimatedDelete) {
              searchTypeSpeed /= 4;
            }
            if (!searchAnimatedDelete && searchAnimatedCharIndex === searchCurrentWord.length) {
              searchTypeSpeed = 500;
              searchAnimatedDelete = true;
            } else if (searchAnimatedDelete && searchAnimatedCharIndex === 0) {
              searchAnimatedDelete = false;
              searchAnimatedIndex++;
              searchTypeSpeed = 500;
            }
            setTimeout(searchTypedWord, searchTypeSpeed);
          }
          searchTypedWord();
        }
      } else {
        if (searchAnimatedContainer) {
          searchAnimatedContainer.classList.remove('typed');
          searchAnimatedContainer.innerHTML = searchAnimatedArray[0];
        }
      }
    });
  }

  toggleResetButton() {
    const resetIsHidden = this.resetButton.classList.contains('hidden');
    if (this.input.value.length > 0 && resetIsHidden) {
      this.resetButton.classList.remove('hidden');
    } else if (this.input.value.length === 0 && !resetIsHidden) {
      this.resetButton.classList.add('hidden');
    }
  }

  onChange() {
    this.toggleResetButton();
  }

  shouldResetForm() {
    return !document.querySelector('[aria-selected="true"] a');
  }

  onFormReset(event) {
    // Prevent default so the form reset doesn't set the value gotten from the url on page load
    event.preventDefault();
    // Don't reset if the user has selected an element on the predictive search dropdown
    if (this.shouldResetForm()) {
      this.input.value = '';
      this.input.focus();
      this.toggleResetButton();
    }
  }
}

customElements.define('search-form', SearchForm);